import React, { useContext, useEffect } from 'react';
import { DataContext } from '../contexts/DataContext';

const NetRevenue = () => {
  const { netRevenue, fetchGetNetRevenue, isLoading, anticiposByReference, fetchAnticiposByReference } = useContext(DataContext);

  useEffect(() => {
    // This will trigger the net revenue data fetching when the component mounts
    fetchAnticiposByReference();
  }, [fetchAnticiposByReference]);

  if (isLoading) {
    return <p>Loading...</p>;
  }

  if (!anticiposByReference) {
    return <p>No net revenue data available.</p>;
  }

  // Render your net revenue data as needed
  return (
    <div>
      <h2>Net Revenue Data</h2>
      <pre>{JSON.stringify(anticiposByReference, null, 2)}</pre>
    </div>
  );
};

export default NetRevenue;
